import pick from 'lodash/pick';
import { FieldPath, FieldValues, useController } from 'react-hook-form';

import { HookFormBaseProps, UseHookFormResult } from './useHookForm.types';
import { hookFormControllerProps } from './utils/hookFormControllerProps';

/** Represents a hook for creating a React Hook Form based component. */
export function useHookForm<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>(
  props: HookFormBaseProps<TFieldValues, TName>,
): UseHookFormResult<TFieldValues, TName> {
  const controllerProps = pick(props, hookFormControllerProps);
  const controller = useController(controllerProps);

  return {
    controller,
    controllerProps,
  };
}
